import React from 'react'
import s from './instruments-setting.module.scss'
import { SettingRow } from '../setting-row/setting-row';
import { Controller } from 'react-hook-form';
import Select, { components } from "react-select";
import { Button } from '@shared/ui/button/button';
import { IconPlus, IconX } from '@tabler/icons-react';
import { useAllInstruments } from '@shared/api/useAllInstruments';

const DropdownIndicator = (props) => {
	return (
		components.DropdownIndicator && (
			<components.DropdownIndicator {...props}>
				<Button
					label={<IconPlus size={16} />}
					size="small"
					className={s.plusBtn}
				/>
			</components.DropdownIndicator>
		)
	);
};

const MultiValueRemove = (props) => {
	return (
		components.MultiValueRemove && (
			<components.MultiValueRemove {...props}>
				<IconX size={16} />
			</components.MultiValueRemove>
		)
	);
};


export const InstrumentsSetting = ({methods}) => {
	const { data: instruments } = useAllInstruments();

	return (
		<SettingRow title={'Инструменты'} withoutBorders={true}>
				<div className={s.instruments}>
						<Controller
							name="instruments"
							control={methods?.control}
							render={({ field }) => (
								<div className={s.instrumentsEdit}>
									<Select
										{...field}
										options={instruments?.map((i) => ({
											label: i.name,
											options: i?.instruments?.map((ingroup) => ({
												value: ingroup.id,
												label: ingroup.name,
											})),
										}))}
										isMulti
										isSearchable={false}
										backspaceRemovesValue
										placeholder="Выберите инструменты"
										className={s.select}
										onChange={(value) => {
											field.onChange(value);
										}}
										styles={{
											control: (baseStyles, state) => ({
												...baseStyles,
												outline: "none",
												boxShadow: "none",
												padding: 0,
												border: "none",
												borderRadius: ".75rem",
												minHeight: 0,
												backgroundColor: "var(--bg-elevated)",
											}),
											valueContainer: (baseStyles) => ({
												...baseStyles,
												padding: 0,
											}),
											multiValue: (baseStyles) => ({
												...baseStyles,
												backgroundColor: "var(--bg-active)",
												borderRadius: ".5rem",
												color: "#000",
												padding: ".5rem .35rem",
												"&:hover": {
													background: "var(--bg-active)",
												},
											}),
											multiValueRemove: (baseStyles) => ({
												...baseStyles,
												cursor: "pointer",
												"&:hover": {
													background: "none",
												},
											}),
											menu: (baseStyles) => ({
												...baseStyles,
												backgroundColor: "var(--bg-elevated)",
												borderRadius: 10,
												padding: 8,
												boxShadow:
													"rgba(0, 0, 0, 0.05) 0px 6px 24px 0px",
											}),
											option: (baseStyles, { isSelected }) => ({
												...baseStyles,
												padding: "0.5rem 1rem",
												borderRadius: 4,
												color: "var(--text-secondary)",
												fontSize: "1rem",
												lineHeight: "1.5rem",
												cursor: "pointer",
												background: isSelected ? "var(--bg-active)" : "none",
												"&:hover": {
													background: "#f1f1f1",
												},
											}),
											multiValueLabel: (baseStyles) => ({
												...baseStyles,
												color: "#000",
												fontSize: ".875rem",
												fontWeight: "500",
												lineHeight: "100%",
											}),
											indicatorsContainer: (base) => ({
												...base,
												padding: 0,
											}),
											dropdownIndicator: (base) => ({
												...base,
												padding: 0,
												alignSelf: "flex-start",
											}),
										}}
										isClearable={false}
										components={{
											DropdownIndicator,
											MultiValueRemove,
											IndicatorSeparator: "",
										}}
									/>
								</div>
							)}
						/>
					</div>
		</SettingRow>
	)
}
